<template>
  <el-dialog
  title="添加功能"
  :visible.sync="dialogVisible"
  :close-on-click-modal="false"
  width="500px"
  :before-close="close">
    <div class="functionality-root">
     1
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
    </span>

  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods:{
    open(item){
      this.dialogVisible = true;
    },
    close(){
      this.dialogVisible = false;
    }
  }
}
</script>

<style lang="scss" scoped>

.functionality-root{
  width: 100%;
  height: 100%;
}
 ::v-deep .el-dialog__header{
    width: 92%;
    height: 23px;
    // background: #F8F9FA;
    box-shadow: 0px 1px 0px 0px rgb(237 238 240);
    border-radius: 12px 12px 0 0;
    margin-bottom: 20px;
   }
   ::v-deep .el-dialog{
    border-radius: 12px;
   }
</style>